import {Injectable} from '@angular/core';
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class TerminalService {
  constructor(public http: HttpClient,
              public config: IndexConfigService) {
  }

  @Load()
  execute(model: any) {
    return this.http.put<any>(this.config.api + '/api/terminal/execute', model);
  }
}
